import { APPLICANT_TYPES } from "shared/config/constants";
import { useActiveCompany } from "shared/hooks";
import { useGetApplicantTypes } from "shared/hooks/api";

export const useInviteApplicantTypes = () => {
  const { activeCompany } = useActiveCompany();
  const shouldHideOccupants = Boolean(
    (activeCompany as any)?.hideOccupantsButAllowDependents
  );
  const { applicantTypes, isLoading: applicantTypesLoading } =
    useGetApplicantTypes();
  const filteredApplicantTypes = shouldHideOccupants
    ? applicantTypes?.filter(
        ({ id }) => Number(id) !== APPLICANT_TYPES.occupant
      )
    : applicantTypes;

  return {
    applicantTypes: filteredApplicantTypes,
    applicantTypesLoading,
  };
};
